import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Textarea,
  ModalFooter,
  Button,
  Text,
} from "@chakra-ui/react";
import { PHONE_CAMPAIGN_FIELDS } from "./CampaignConstants";

const PhoneCampaignModal = ({
                              isOpen,
                              onClose,
                              onAddCampaignOpen,
                              campaignType,
                              textAreaRef,
                              customizedTemplate,
                              setCustomizedTemplate,
                              setIsConfigVisible,
                              handleFocus,
                              handleBlur,
                              isEditing,
                              setIsEditing,
                              saveCampaign
                            }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size={"6xl"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Phone Message Content</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {PHONE_CAMPAIGN_FIELDS
            .filter((f) =>
              campaignType === "manual" ? f.manual : f.key !== "call_context"
            )
            .filter(
              (f) => !f.aiOnly || customizedTemplate?.settings?.ai_enabled
            )
            .map((field, idx) => (
              <FormControl key={field.key} mt={idx > 0 ? 2 : 0}>
                <FormLabel>{field.label}</FormLabel>
                {field.readOnly ? (
                  <Text>
                    {customizedTemplate?.template?.phone?.[field.key]?.text}
                  </Text>
                ) : (
                  <Textarea
                    ref={textAreaRef}
                    value={
                      customizedTemplate?.template?.phone?.[field.key]?.text ??
                      ""
                    }
                    onFocus={() =>
                      handleFocus(["template", "phone", field.key, "text"])
                    }
                    onBlur={handleBlur}
                    onChange={(e) => {
                      setCustomizedTemplate({
                        ...customizedTemplate,
                        template: {
                          ...customizedTemplate.template,
                          phone: {
                            ...customizedTemplate.template.phone,
                            [field.key]: {
                              ...customizedTemplate.template.phone?.[field.key],
                              text: e.target.value,
                            },
                          },
                        },
                      });
                    }}
                  />
                )}
              </FormControl>
            ))}
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            onClick={() => {
              onClose();
              if (!isEditing) {
                onAddCampaignOpen();
              } else {
                setIsEditing(false);
              }
            }}
          >
            Back
          </Button>
          <Button
            marginLeft="10px"
            colorScheme="blue"
            mr={3}
            onClick={async () => {
              onClose();
              if (!isEditing) {
                setIsConfigVisible(true);
              } else {
                await saveCampaign();
                setIsEditing(false);
              }
            }}
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PhoneCampaignModal;
